"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableModificators = void 0;
const react_1 = require("react");
const tariffGroupMapper_1 = require("../../../TariffsTable/tariffGroupMapper");
const useTableModificators = (highlightReservationId) => (0, react_1.useMemo)(() => ({
    row: (row) => {
        const { isAppeared, tariff, reservation } = row.original;
        const tariffCode = (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff === null || tariff === void 0 ? void 0 : tariff.group.id);
        return [
            tariffCode === 'business' ? 'blue-line' : undefined,
            isAppeared === true ? 'appeared' : undefined,
            isAppeared === false ? 'not-appeared' : undefined,
            reservation.id === highlightReservationId ? 'highlight' : undefined,
        ];
    },
    column: (column) => column.disableShowForDevice ? 'device-hidden' : undefined,
}), [highlightReservationId]);
exports.useTableModificators = useTableModificators;
//# sourceMappingURL=utils.js.map